import type { Category } from '@/types/course';

export const categories: Category[] = [
  {
    id: 'lang',
    name: '语言学习',
    icon: 'ri-translate-2',
    desc: '英语、日语、韩语等语言系统课程，从零基础到进阶口语与应试全覆盖。',
    subcategories: ['英语', '日语', '韩语', '雅思托福'],
  },
  {
    id: 'it',
    name: 'IT技术',
    icon: 'ri-code-s-slash-line',
    desc: '前端、后端、数据分析与人工智能，紧跟行业主流技术栈的实战课程。',
    subcategories: ['前端开发', '后端开发', '数据分析', '人工智能'],
  },
  {
    id: 'finance',
    name: '财经管理',
    icon: 'ri-bar-chart-box-line',
    desc: '会计基础、金融投资与经济管理，帮助你建立扎实的商业思维与财务能力。',
    subcategories: ['会计基础', '金融投资', '经济管理'],
  },
  {
    id: 'career',
    name: '职业技能',
    icon: 'ri-briefcase-4-line',
    desc: '办公技能、职场沟通与项目管理，提升职场竞争力与协作效率。',
    subcategories: ['办公技能', '职场沟通', '项目管理'],
  },
  {
    id: 'design',
    name: '设计创意',
    icon: 'ri-palette-line',
    desc: 'UI 设计、平面设计与视频剪辑，用审美与工具把创意真正落地。',
    subcategories: ['UI设计', '平面设计', '视频剪辑'],
  },
  {
    id: 'exam',
    name: '考试考证',
    icon: 'ri-award-line',
    desc: '考研、公务员与教师资格等热门考证课程，系统规划高效备考路线。',
    subcategories: ['考研', '公务员', '教师资格'],
  },
];